var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg1 = function Svg1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "1_svg__a",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogdXJsKCNsaW5lYXItZ3JhZGllbnQpOwogICAgICB9CiAgICA8L3N0eWxlPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQiIHgxPSIyNCIgeDI9IjI0IiB5Mj0iNDgiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZmY5NzAwIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2Y5MTMwYiIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiLz4KPC9zdmc+Cg==",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    preserveAspectRatio: "none",
    result: "image"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in",
    result: "composite"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "SourceGraphic",
    result: "blend"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.188v34.063l23.8 11.758L48 36.251V0H0z",
    "data-name": "\\u5F62\\u72B6 26",
    style: {
      fill: "#f9130b",
      fillRule: "evenodd",
      filter: "url(#1_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": 1,
    style: {
      fontSize: 35,
      fill: "#fff",
      fontFamily: "&quot"
    },
    transform: "matrix(.96 0 0 .96 14.5 33.153)"
  }, "1"));
};
export default Svg1;